export const imageUrl = (image: string) => {
  const base = (import.meta.env.VITE_APP_URL || "").replace(/\/$/, "");
  return `${base}/image/${encodeURIComponent(image)}`;
};
